const BACK_OFFICE_MASTER_DATA_URL = "/master-data/posting-setup";

export default [
  {
    level:3,
    key: "title.generalPostingSetup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/general-posting-setup`,
  },
  {
    level:3,
    key: "title.inventoryPostingSetup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/inventory-posting-setup`,
  },
  {
    level:3,
    key: "title.userPostingSetup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/user-posting-setup`,
  },
  {
    level:3,
    key: "title.purchasePayableSetup",
    link: "/payable/setup",
  },
  {
    level:3,
    key: "title.salesReceivableSetup",
    link: "/receivable/setup",
  },
  {
    level:3,
    key: "title.generalLedgerSetup",
    link: "/ledger/setup",
  },
  {
    level:3,
    key: "title.inventoryReconciliationSetup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/inventory-reconciliation-setup`,
  },
  {
    level:3,
    key: "title.inventorySetup",
    link: "/inventory/setup",
  },
];
